import { Row } from "react-bootstrap";
import classNames from "classnames";
import { UtilisateurEntity } from "../../Entities/UtilisateurEntity.tsx";
import { useAppContext } from "../../components/App/AppProvider.tsx";
import { IconCoucou } from "../../components/Icon/Icon.tsx";
import RessourcesProche from "../Ressources/Proche/RessourcesProche.tsx";
import AccueilAdmin from "./AccueilAdmin.tsx";
import styles from "./AccueilAuth.module.css";

const AccueilAuth = () => {
  const { user }: { user: UtilisateurEntity } = useAppContext();

  return (
    <Row className={"px-0 px-lg-5"}>
      <Row>
        <h1 className={classNames(styles.title, "text-primary-100 mb-4")}>
          <span className={"me-2 text-primary"}>
            <IconCoucou />
          </span>
          <b>Bienvenue</b> sur votre espace FAME
        </h1>
      </Row>

      <Row className={"px-0 px-lg-5"}>
        <main className={styles.authContent}>
          {user.isAdministrateur ? (
            <AccueilAdmin />
          ) : (
            user.isProche && <RessourcesProche />
          )}
        </main>
      </Row>
    </Row>
  );
};

export default AccueilAuth;
